import React from 'react';
import { useSSR } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import 'components/i18n';
import { ThemeProvider, StyleSheetManager } from 'styled-components';

import getStore from 'redux/store';

import PromoErrorBoundary from 'components/utils/PromoErrorBoundary';

import isPropValid from '@emotion/is-prop-valid';
import { hydrateRoot } from 'react-dom/client';
import 'static/css/global.css';
import 'static/css/fonts.css';
import 'static/css/promo-common.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import promoRoutes from 'routes/promoRoutes';

import App from '../components/App/App';
import { USER_THEME_DARK, USER_THEME_LIGHT } from '../constants/Constants';
import { getShortActiveRoute } from '../routes/routesNoAuthUtils';
import { isShortActiveUrl, pushPath } from '../routes/routesUtils';
import pallets from '../theme/pallets';

const preloadedState = window.__INITIAL_STATE__;
delete window.__INITIAL_STATE__;
const store = getStore(preloadedState);
const state = store.getState();
const isShortLink = isShortActiveUrl(location.pathname);

const preprocessRoutes = isShortLink ? getShortActiveRoute(location.pathname) : pushPath(promoRoutes, []);

const PromoHydryte = () => {
    useSSR(window.initialI18nStore, window.initialLanguage);

    const params = new URLSearchParams(location.search.substring(1));
    const theme = params.get('mode') === USER_THEME_DARK ? USER_THEME_DARK : USER_THEME_LIGHT;

    return (
        <BrowserRouter>
            <StyleSheetManager shouldForwardProp={isPropValid}>
                <ThemeProvider theme={pallets[theme]}>
                    <Provider store={store}>
                        <PromoErrorBoundary>
                            <App authUser={state.auth.authUser} redirectTo={state.app.redirectTo} routes={preprocessRoutes} />
                        </PromoErrorBoundary>
                    </Provider>
                </ThemeProvider>
            </StyleSheetManager>
        </BrowserRouter>
    );
};
const container = document.getElementById('app');
hydrateRoot(container, <PromoHydryte />);
